const isTarget = (organizationName?: string) => (
  organizationName?.toLowerCase() === "target"
);

export default isTarget;
